module.exports = __webpack_public_path__ + "assets/img/enterprise-1.d5c769ff.png";